import audio from '../assets/images/FileViewerImages/AUDIO.svg';
import code from '../assets/images/FileViewerImages/CODE.svg';
import csv from '../assets/images/FileViewerImages/CSV.svg';
import doc from '../assets/images/FileViewerImages/DOC.svg';
import docx from '../assets/images/FileViewerImages/DOCX.svg';
import file from '../assets/images/FileViewerImages/FILE.svg';
import img from '../assets/images/FileViewerImages/IMG.svg';
import pdf from '../assets/images/FileViewerImages/PDF.svg';
import rar from '../assets/images/FileViewerImages/RAR.svg';
import txt from '../assets/images/FileViewerImages/TXT.svg';
import video from '../assets/images/FileViewerImages/VIDEO.svg';
import xlsx from '../assets/images/FileViewerImages/XSL.svg';
import zip from '../assets/images/FileViewerImages/ZIP.svg';

const IMAGE_EXTENSIONS = new Set([
  'jpg',
  'jpeg',
  'png',
  'webp',
  'bmp',
  'tif',
  'tiff',
  'heic',
  'heif',
  'avif',
]);

export const useGetFileIcon = () => {
  const isImageFile = (fileName: string): boolean => {
    if (fileName.startsWith('data:image/')) return true;
    const ext = fileName.split('.').pop()?.toLowerCase() ?? '';
    return IMAGE_EXTENSIONS.has(ext);
  };

  const getFileIcon = (fileName: string, needsImageIcon?: boolean) => {
    if (isImageFile(fileName)) {
      return needsImageIcon ? img : fileName;
    }

    const extension = fileName.split('.').pop()?.toLowerCase() ?? '';

    switch (extension) {
      case 'pdf':
        return pdf;
      case 'mp4':
      case 'mkv':
      case 'webm':
        return video;
      case 'mp3':
      case 'wav':
        return audio;
      case 'zip':
        return zip;
      case 'rar':
        return rar;
      case 'xlsx':
      case 'ods':
        return xlsx;
      case 'csv':
        return csv;
      case 'js':
      case 'ts':
      case 'html':
      case 'css':
      case 'json':
        return code;
      case 'doc':
      case 'odt':
        return doc;
      case 'docx':
      case 'pptx':
      case 'odp':
        return docx;
      case 'txt':
      case 'md':
      case 'markdown':
        return txt;
      default:
        return file;
    }
  };

  return { getFileIcon, isImageFile };
};
